module.exports = __webpack_public_path__ + "94bacb2418cf58b524752178cf582143.svg";